
export enum UserRole {
	CLINICIAN = "Clinician",
	AUDITOR = "Auditor",
	VIEW_ADHOC_ENCOUNTERS = "ViewAdhocEncounters",
	APP_ADMIN = "AppAdmin",
	PRINT_MEDICAL_RECORDS = "PrintMedicalRecords",
	WIFI_DISABLE = "WifiDisable",
}

export interface UserIdentity {
	upn: string
	username: string
	fullName: string
	roles: UserRole[]
}
